
    jQuery(document).ready(function($){

        objectFitVideos(document.getElementById('background-video'));
      
        // adds a class to any external link on the site
        $('a[href^="http"],a[href^="https"]').each(function() {
           var a = new RegExp('/' + window.location.host + '/');
           if (!a.test(this.href)) {
               $(this).addClass('external-link');
           }
        });

        /* The list item above a related nav block does not need the border bottom */
        $( ".main-nav-div.dropdown-pane li.related-nav" ).prev("li").children("a").css( "border-bottom", "0" );

        /* If there is an emergency banner on this page, add a class to the body */
        if($("#emergencywrapper").length) {
          $('body').addClass('has-emergency-banner');
        }

        function closeLargeMainNav(){
         
          // Closes large view mega nav
          $("#nav-background-fill").height(0);
          $('.main-nav-div.dropdown-pane').each(function() {
            if ($(this).hasClass("is-open")) {
              $(this).toggleClass("is-open");
            }
          });
          $('h3>a.top-nav-toggle').each(function() {
              if (($(this).hasClass("hover"))&&($(this).attr('aria-expanded') == "true")) {
                $(this).attr("aria-expanded","false");
                $(this).toggleClass("hover");
              }
          });
          
        }
        function closeMobileMainNav(){
          $('#main-nav').removeClass('off-canvas in-canvas-for-large position-right');

           // closes small view mega nav
          if ( $('#main-nav').hasClass( 'is-open' ) ) {
             $('.off-canvas-content').removeClass('is-open-right has-transition-overlap has-position-right');
             $('#main-nav').foundation('close');
          }
        }

        function social_media_icons(e){
          /* If there is a social media link in the secondary nav, append a down and up chevron to it and tabindex 0 */
          $("#menu-secondary-navigation .social.menu-item-has-children>a").html("Social&nbsp;&nbsp;<i class='fas fa-chevron-down'></i>");
          $("#menu-secondary-navigation .social.menu-item-has-children>a").attr('tabindex', '0');
          
          /* append the appropriate icon to the social media list in both the section nav and the social media drop down */
          $("li.social li.facebook>a").html("facebook<i class='fab fa-facebook-square'></i>");
          $("li.social li.linkedin>a").html("linked in<i class='fab fa-linkedin-in'></i>");
          $("li.social li.instagram>a").html("instagram<i class='fab fa-instagram'></i>");
          $("li.social li.youtube>a").html("youtube<i class='fab fa-youtube'></i>");
          $("li.social li.flickr>a").html("flickr<i class='fab fa-flickr'></i>");
          $("li.social li.twitter>a").html("twitter<i class='fab fa-twitter'></i>");
          

        }

      
      if ($(window).width() < 1024) {
          $('#main-nav').appendTo('#small-nav-place');
          $('#masthead-secondary-nav').appendTo('#main-nav-wrapper');
          //$('#q').attr('placeholder', 'Search...');
          if ($('#main-nav').hasClass('off-canvas')){
            //do nothing
              
          }
          else {
            $('#main-nav').addClass('off-canvas in-canvas-for-large position-right');
          }

      }


      



      $(window).on('resize',function(){
        
    		if ($('#q').is(':focus')) {
    			// do nothing
    			
    		} else {
    			
    			
    			if ($(window).width() < 1024) {   
    			  $('#main-nav').appendTo('#small-nav-place');
            $('#masthead-secondary-nav').appendTo('#main-nav-wrapper');
            

            //$('#q').attr('placeholder', 'Search...');
    				if ($('#main-nav').hasClass('off-canvas')){
    				  //do nothing, already in mobile view
    					
    				}
    				else {
    				  $('#main-nav').addClass('off-canvas in-canvas-for-large position-right');
    				}
    			  
    			  
    			} else {  
    			  $('#main-nav').appendTo('#large-nav-place');
            $('#masthead-secondary-nav').appendTo('#secondary-nav-large');
            //$('#q').attr('placeholder', 'Search for people, places and more...');
    				if ($('#main-nav').hasClass('off-canvas')){
    				  
              // if going from mobile view to desktop view, close all navigation 
              closeMobileMainNav();
              closeLargeMainNav();
    					
    				}
    			}
    		}

      }); 


      $('#nav-menu-button').click(function() { setTimeout(function() {
              
                if ( $( '#main-nav' ).is( '.is-open' ) ) {
                    $('#nav-menu-close').get(0).focus();
                 
                       
                }
                else {
                   $('#nav-menu-button').get(0).focus();
                
                }   
              
      }, 100); });

      $('#nav-menu-close').click(function() { setTimeout(function() {
              
                if ( $( '#main-nav' ).not( '.is-open' ) ) {
                  $('#nav-menu-button').get(0).focus();
                    
                }
                else {
                  $('#nav-menu-close').get(0).focus();
                  
                }   
              
      }, 100); });

      /* This creates the full width green background behind mega nav dropdown panel when it's open*/
      $('.top-nav-toggle').click(function() { setTimeout(function() {
        if ($(window).width() > 1024) {
          var tallness = 0; 

          if ($(".main-nav-div.dropdown-pane.is-open")[0]){
              tallness = $(".main-nav-div.dropdown-pane.is-open").height() + 93;
             
          } else {
              var tallness = 0;
          }
          $("#nav-background-fill").height(tallness);

          /* make sure related nav is not hidden when a top level nav is clicked */
          $('.main-nav-div li.related-nav').show();
        }
       }, 1); });

      /* The main nav and the the green background needs to close when clicked outside of nav div */
      $(document).on("click", function () {
        if ($(window).width() > 1024) {
            if (!$(event.target).closest("#large-nav-place").length) {
              closeLargeMainNav();
            }
          }
      });


      /* If a third level menu is toggled open, the others should close */
      $('a.sub-menu-toggle').click(function(e) {
          $(this).toggleClass('div-open');

          $('a.sub-menu-toggle').not(this).each(function() {
            if ($(this).hasClass("div-open")) {
              $(this).toggleClass('div-open');
            }
          });

          var ID = '#'+($(this).attr("data-toggle"));
          $('div.sub-nav-div'+ID).foundation('toggle');

          $('div.sub-nav-div').not(ID).each(function() {
            if ($(this).hasClass("sub-open")) {
              $(this).foundation('toggle');
            }
          });
          /* if the second column of the third level sub menu has links, 
          the related news should be hidden and the second column of links
          should be displayed in its place */
          
           if ( ($('div.sub-nav-div'+ID+' ul.ssubcol2 li').length > 0 ) && ($(this).hasClass("div-open")) ){
            if ($(window).width() > 1024) {
              $('.main-nav-div li.related-nav').hide();
            }
           }
          else {
            $('.main-nav-div li.related-nav').show();
          }

           

          e.stopImmediatePropagation();
      });

      /* If a first level nav is clicked, all sub menus should be closed to start */
      $('a.top-nav-toggle').click(function() {

        var ID = '#'+($(this).attr("data-toggle"));
        $('div.main-nav-div'+ID).foundation('toggle'); 

        $('div.sub-nav-div').each(function() {
          if ($(this).hasClass("sub-open")) {
            $(this).foundation('toggle');
          }
        });

        $('a.sub-menu-toggle').each(function() {
          if ($(this).hasClass("div-open")) {
            $(this).toggleClass("div-open");
          }
        });

      });

    
      /* Secondary nav and social dropdown under search bar */
      $("#menu-secondary-navigation .social.menu-item-has-children>a").click(function(e) {
        $(this).toggleClass("social-open");
        $(".social>ul.sub-menu").toggleClass("social-ul-open");
          e.stopImmediatePropagation();
      });

      $("#menu-secondary-navigation .social.menu-item-has-children>a").keypress(function(event){
        if(event.keyCode == 13){
          $(this).toggleClass("social-open");
          $(".social>ul.sub-menu").toggleClass("social-ul-open");
          e.stopImmediatePropagation();
        }
      });  
      
      $(document).on("click", function () {
        // when you click off social media, close it
          if ($("#menu-secondary-navigation .social.menu-item-has-children>a").hasClass("social-open")) {
            if (!$(event.target).closest("ul.social-ul-open").length) {
              $("#menu-secondary-navigation .social.menu-item-has-children>a").toggleClass("social-open");
              $(".social>ul.sub-menu").toggleClass("social-ul-open");
            }
          }

          // when you click off the action buttons on small screens, close it
          if ($(window).width() < 1024) {
            if (!$(event.target).closest(".abuttons").length) {
              if ($('#abuttonslist').hasClass('expanded')) {
                $('#abuttonslist').removeClass('expanded');
              }
              
            }
          }
      });


      /* On small screens, do not show the action buttons until the user has scrolled down the page past the masthead */
      
       $(window).on("load resize scroll",function(e){
         
          if ($(window).width() < 1024) {
        
              var y = $(this).scrollTop();
              if (y > 100) {
                $('div.action-bar-wrapper').fadeIn();
              } else {
                $('div.action-bar-wrapper').fadeOut();
              }
           }
           else {
            $('div.action-bar-wrapper').fadeIn();
           }

        });
        

       /* Top Button and CTA button bar */
       
       /* If there are CTA buttons, the action bar should have width 100% */
        if ($('.action-padding .action-flex').hasClass('has-buttons')) {
            $('div.action-padding').css({'width': '100%'});
        }

       /* scroll to top of page button that lives with the CTA buttons */ 
       $("a[href='#pagetop']").click(function() {
         $("html, body").animate({ scrollTop: 0 }, "slow");
         return false;
       });




      social_media_icons();

  });






      

